/* eslint-disable @typescript-eslint/no-explicit-any */
import { useNotification } from '@/containers'
import { Meta } from '@/layouts/Meta'
import { Main } from '@/templates/Main'
import { type Post } from '@/types'
import { getTranslate, setContext } from '@/utils/api-interceptors'
import { getPostDetail, getSaleRegion } from '@/utils/endpoint'
import * as pixel from '@/utils/fpixel'
import { getCookies } from 'cookies-next'
import dayjs from 'dayjs'
import { type GetServerSideProps, type GetServerSidePropsContext } from 'next'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
const PostDetail = ({
  postDetail,
  hideMenu,
}: {
  postDetail: Post
  hideMenu: string
}) => {
  const router = useRouter()
  const { systemConfig } = useNotification()
  useEffect(() => {
    pixel.fbqEvent('ViewContent')
  }, [])
  return (
    <Main
      showRecentlyViewed
      meta={
        <Meta
          title={getTranslate(postDetail?.title)}
          description={getTranslate(postDetail?.title)}
          canonical={process.env.NEXT_PUBLIC_URL_WEBSITE + router.asPath}
          imageUrl={
            postDetail?.images[0] ||
            systemConfig?.imagePlaceholder ||
            process.env.NEXT_PUBLIC_IMAGE_PLACEHOLDER ||
            ''
          }
        />
      }
      dataHeader={getTranslate(postDetail?.title)}
      pageLayout=''
      btnHome={true}
      hideMenu={hideMenu === 'true'}
      bgColor='#ffffff'
    >
      {postDetail?.cssMobile && (
        <Head>
          <style dangerouslySetInnerHTML={{ __html: postDetail.cssMobile }} />
        </Head>
      )}
      <div className='postDetail container pt-4 pb-10'>
        <h1 className='text-titleSection font-bold text-dark-400'>
          {getTranslate(postDetail?.title)}
        </h1>
        <span className='mt-[5px] text-titleProduct text-dark-500 italic font-normal'>
          {dayjs(postDetail?.createdAt).format('HH:mm DD/MM/YYYY')}
        </span>
        <div className='mb-2 mt-3 italic text-dark-400'>
          {getTranslate(postDetail?.description)}
        </div>
        <div
          className='main-description break-words leading-5'
          dangerouslySetInnerHTML={{
            __html: getTranslate(postDetail?.content),
          }}
        ></div>
      </div>
    </Main>
  )
}

export default PostDetail

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const { req, res, query } = context
  const { token, language, messages } = await setContext(
    getCookies({ req, res }),
    {
      language: context.locale,
    }
  )

  const { slug, hideMenu } = query
  if (!slug) {
    return {
      notFound: true,
    }
  }

  const [postDetail, regions] = await Promise.all([
    getPostDetail((slug as string).replace('.b', '')),
    getSaleRegion(),
  ])

  return {
    props: {
      language,
      regions,
      messages,
      postDetail,
      hideMenu: hideMenu || null,
      token: token || null,
    },
  }
}
